import fuzzydate from 'util/fuzzydate';
import {WorkflowTemplateVersionSummary} from 'workflows/WorkflowConstants';

export function getWorkflowTemplateVersionVersionLabel(
  workflowTemplateVersion: WorkflowTemplateVersionSummary
): string {
  return workflowTemplateVersion.version
    ? `Version ${workflowTemplateVersion.version}`
    : `Draft (${fuzzydate(workflowTemplateVersion.modifiedAt)})`;
}
